export const USER_TABLE_V2_PAGE_SIZE = 100;
export const USER_TABLE_V2_CACHE_BLOCK_SIZE = 25;
export const USER_BULK_ACTION_POLL_INTERVAL_MS = 2_000;
export const USER_BULK_ACTION_TOAST_DURATION_MS = 5_000;

// Horizontal gap (px) between chips in the Labels column. Used to compute how many chips fit before the `+N` overflow.
export const USER_TABLE_V2_LABEL_CHIP_GAP_PX = 4;

// Approximate width (px) reserved for the `+N` overflow chip when at least one label can't be shown.
export const USER_TABLE_V2_LABEL_OVERFLOW_CHIP_WIDTH_PX = 40;

export const USER_STATUS = {
  Active: 'active',
  Pending: 'pending',
  PendingExistingUser: 'pending_existing_user',
  PendingNewUser: 'pending_new_user',
  Expired: 'expired',
  Deactivated: 'deactivated',
  DeactivatedSystem: 'deactivated_system',
} as const;

export type UserStatus = (typeof USER_STATUS)[keyof typeof USER_STATUS];
